namespace RedBullMOBILE360.SpecialEvent {
    export interface SpecialEventForm {
        EventName: Serenity.StringEditor;
        ImageUrl: Serenity.ImageUploadEditor;
    }

    export class SpecialEventForm extends Serenity.PrefixedContext {
        static formKey = 'SpecialEvent.SpecialEvent';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SpecialEventForm.init)  {
                SpecialEventForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ImageUploadEditor;

                Q.initFormType(SpecialEventForm, [
                    'EventName', w0,
                    'ImageUrl', w1
                ]);
            }
        }
    }
}
